import { v4 as uuidv4 } from "uuid";
export class EmailSettingModel {
    constructor() {
        this.id = uuidv4();
        this.organizationSettingId = uuidv4();
        this.smtpServer = "";
        this.smtpPort = 0;
        this.smtpUsername = "";
        this.smtpPassword = "";
        this.fromMail = "";
        this.isVerified = false;
    }
}
export default class EmailSetting extends EmailSettingModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
